
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
const $388b617130f03bd4$var$app = {
    fn: {
        run: null
    },
    lib: {
        i18n: null,
        settings: null,
        token: null
    },
    run: {
        headers: null,
        i18n: null,
        route: null,
        router: null,
        settings: null,
        token: null
    }
};
$388b617130f03bd4$var$app.fn.run = async ()=>{
    $388b617130f03bd4$var$app.lib.i18n.detect();
    await $388b617130f03bd4$var$app.lib.token.run();
    await $388b617130f03bd4$var$app.lib.settings.run();
    $388b617130f03bd4$var$app.lib.i18n.render();
    $388b617130f03bd4$var$app.lib.router(window.location.hash);
    window.addEventListener('hashchange', ()=>{
        $388b617130f03bd4$var$app.lib.router(window.location.hash);
    });
    document.getElementById('app-loader').classList.add('d-none');
    console.log($388b617130f03bd4$var$app);
/*
  document.title = app.conf.title;


  document.getElementById('app-loader').classList.add('d-none');
  */ };
var $388b617130f03bd4$export$2e2bcd8739ae039 = $388b617130f03bd4$var$app;



const $9e30b5b5de697b16$var$i18n = {
    detect: ()=>{
        // add localStorage
        if (navigator.language === 'en' || navigator.language.match(/^en\-(.+)/)) (0, $388b617130f03bd4$export$2e2bcd8739ae039).run.i18n = 'en';
        else (0, $388b617130f03bd4$export$2e2bcd8739ae039).run.i18n = 'en';
    },
    render: ()=>{
        //document.title = app.run.settings.siteTitle;
        /*
    const title = `${app.run.settings.view[app.route].pageTitle}${app.run.settings.siteTitleSeparator}${app.run.settings.siteTitle}`;
    document.title = title;
    */ let attribute = '';
        attribute = 'data-i18n';
        Array.from(document.querySelectorAll(`[${attribute}]`)).forEach((element)=>{
            const attributeArray = element.getAttribute(attribute).split('-');
            element.innerHTML = (0, $388b617130f03bd4$export$2e2bcd8739ae039).run.settings[attributeArray[0]][attributeArray[1]][attributeArray[2]];
        });
        attribute = 'data-i18n-placeholder';
        Array.from(document.querySelectorAll(`[${attribute}]`)).forEach((element)=>{
            const attributeArray = element.getAttribute(attribute).split('-');
            element.setAttribute('placeholder', (0, $388b617130f03bd4$export$2e2bcd8739ae039).run.settings[attributeArray[0]][attributeArray[1]][attributeArray[2]]);
        });
    }
};
var $9e30b5b5de697b16$export$2e2bcd8739ae039 = $9e30b5b5de697b16$var$i18n;



var $8131cadaa5705f51$exports = {};
$8131cadaa5705f51$exports = "<div class=\"align-items-center app-route-landing container d-flex flex-column flex-grow-0 h-100 w-100\">\n\n  <div class=\"end-0 m-3 position-absolute top-0\">\n    <div class=dropdown>\n      <a class=\"btn btn-dark dropdown-toggle\" data-bs-toggle=dropdown href=# role=button>\n        <i class=\"fa-globe fa-solid\"></i>\n      </a>\n      <ul class=dropdown-menu>\n        <li>\n          <a class=\"active dropdown-item\" href=#>\n            English\n          </a>\n        </li>\n      </ul>\n    </div>\n  </div>\n\n  <img alt class=\"app-logo-text d-block m-auto\" src=/logo-text.f78b3fcb.png>\n\n  <div class=text-center>\n    <h1 class=\"d-block mb-5\" data-i18n=view-landing-slogan></h1>\n\n    <p class=\"mb-5 mx-auto\" data-i18n=view-landing-signUpPrompt style=width:80%></p>\n\n    <a class=\"btn btn-primary mb-5\" data-i18n=view-landing-signUp href=#/sign-up style=\"width: 80%;\"></a>\n\n    <p class=mb-1 data-i18n=view-landing-signInPrompt></p>\n\n    <a class=\"btn btn-secondary mb-5\" data-i18n=view-landing-signIn href=#/sign-in style=\"width: 80%;\"></a>\n  </div>\n\n</div>\n";



var $549aaec9bbffe278$export$2e2bcd8739ae039 = ()=>{
    const content = document.createElement('div');
    content.classList.add('align-items-center', 'd-flex', 'justify-content-center', 'mh-100', 'w-100');
    content.innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($8131cadaa5705f51$exports)));
    document.title = `${(0, $388b617130f03bd4$export$2e2bcd8739ae039).run.settings.view.landing.pageTitle}${(0, $388b617130f03bd4$export$2e2bcd8739ae039).run.settings.siteTitleSeparator}${(0, $388b617130f03bd4$export$2e2bcd8739ae039).run.settings.siteTitle}`;
    return content;
};


var $c87716d2bdfe68be$exports = {};
$c87716d2bdfe68be$exports = "<div class=app-route-404>\n\n  <a class=app-logo-text href=/>\n    <img alt src=/logo-text.f78b3fcb.png>\n  </a>\n\n  <div>\n    <h4 class=text-center data-i18n=view-404-pageTitle></h4>\n  </div>\n  \n</div>\n";



var $6e61814d093d589e$export$2e2bcd8739ae039 = ()=>{
    const content = document.createElement('div');
    content.classList.add('align-items-center');
    content.classList.add('d-flex');
    content.classList.add('h-100');
    content.classList.add('justify-content-center');
    content.classList.add('w-100');
    content.innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($c87716d2bdfe68be$exports)));
    const title = `${(0, $388b617130f03bd4$export$2e2bcd8739ae039).run.settings.view[404].pageTitle}${(0, $388b617130f03bd4$export$2e2bcd8739ae039).run.settings.siteTitleSeparator}${(0, $388b617130f03bd4$export$2e2bcd8739ae039).run.settings.siteTitle}`;
    console.log(document.title);
    document.title = '';
    document.title = title;
    console.log(document.title);
    //document.title = `${app.run.settings.view[404].pageTitle}${app.run.settings.siteTitleSeparator}${app.run.settings.siteTitle}`;
    //document.title = 'SATAN!';
    return content;
};



var $f3d78208234397a3$exports = {};
$f3d78208234397a3$exports = "<div class=\"app-route-signIn container\">\n\n  <div class=\"end-0 m-3 position-absolute top-0\">\n    <div class=dropdown>\n      <a class=\"btn btn-dark dropdown-toggle\" data-bs-toggle=dropdown href=# role=button>\n        <i class=\"fa-globe fa-solid\"></i>\n      </a>\n      <ul class=dropdown-menu>\n        <li>\n          <a class=\"active dropdown-item\" href=#>\n            English\n          </a>\n        </li>\n      </ul>\n    </div>\n  </div>\n\n  <img alt class=\"app-logo-text d-block m-auto\" src=/logo-text.f78b3fcb.png>\n\n  <form action=/api/sign-in class=mx-auto id=app-form-signIn method=post style=max-width:25rem>\n\n    <div class=\"alert alert-danger d-none\" data-i18n=view-signIn-error id=view-signIn-error role=alert></div>\n\n    <div class=\"form-floating mb-3\">\n      <input class=form-control data-i18n-placeholder=view-signIn-emailPlaceholder id=app-form-signIn-email name=email required type=email>\n      <label data-i18n=view-signIn-emailLabel for=app-form-signIn-email></label>\n    </div>\n\n    <div class=\"form-floating mb-3\">\n      <input class=form-control data-i18n-placeholder=view-signIn-passwordPlaceholder id=app-form-signIn-password name=password required type=password>\n      <label data-i18n=view-signIn-passwordLabel for=app-form-signIn-password></label>\n    </div>\n\n    <div class=\"align-items-center d-flex\">\n      <a class=text-small data-i18n=view-signIn-forgotPassword href=#/forgot-password></a>\n      <button class=\"btn btn-secondary ms-auto px-4\" data-i18n=view-signIn-submit></button>\n    </div>\n\n  </form>\n\n</div>\n";


var $8981953cfc52913d$export$2e2bcd8739ae039 = ()=>{
    (0, $388b617130f03bd4$export$2e2bcd8739ae039).route = 'signIn';
    const content = document.createElement('div');
    content.classList.add('align-items-center', 'd-flex', 'h-auto', 'justify-content-center', 'mh-100', 'w-100');
    content.innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($f3d78208234397a3$exports)));
    const title = `${(0, $388b617130f03bd4$export$2e2bcd8739ae039).run.settings.view.signIn.pageTitle}${(0, $388b617130f03bd4$export$2e2bcd8739ae039).run.settings.siteTitleSeparator}${(0, $388b617130f03bd4$export$2e2bcd8739ae039).run.settings.siteTitle}`;
    document.title = title;
    const form = content.querySelector('#app-form-signIn');
    form.addEventListener('submit', (e)=>{
        e.preventDefault();
        const data = {};
        const formData = new FormData(form);
        formData.forEach((value, key)=>{
            data[key] = value;
        });
        const json = JSON.stringify(data);
        console.log(formData);
        console.log(data);
        console.log(json);
        const request = new Request(form.action, {
            body: json,
            headers: (0, $388b617130f03bd4$export$2e2bcd8739ae039).run.headers,
            method: 'POST'
        });
        fetch(request).then((response)=>{
            if (!response.ok) throw new Error(`HTTP error ${response.status}`);
            return response.json();
        }).then((data)=>{
            console.log(data);
        }).catch((error)=>{
            console.error(error);
            console.log('SATAN!');
            document.getElementById('view-signIn-error').innerHTML = `<h5><i class="fa-solid fa-fw fa-triangle-exclamation"></i> Sign in failed!</h5> ${error}`;
            document.getElementById('view-signIn-error').classList.remove('d-none');
        });
    /*
    fetch(form.action, {
      body: json,
      headers: app.run.headers,
      method: 'POST',
    }).then((response) => response.json())
    .then((data) => {
        console.log(data);
    });
    */ /*
    fetch(form.action, {
      body: json,
      headers: app.run.headers,
      method: 'POST',
    }).then(async (response) => {
      const json = await response.json();

      if (json) {
        console.log('JSON OK!');
        console.log(json);
        content.querySelector('#view-signIn-error').innerHTML = json.error.text;
        content.querySelector('#view-signIn-error').classList.remove('d-none');
      } else {
        console.log('NOT JSON OK!');
      }

      /*
      if (!response.ok) {
        if (response.json()) {
          console.log('YES, JSON!');
        } else {
          console.log('NOT!');
        }
        content.querySelector('#view-signIn-error').innerHTML = 'Everything went to shit!';
        content.querySelector('#view-signIn-error').classList.remove('d-none');
      } else {
        content.querySelector('#view-signIn-error').innerHTML = 'Everything went to shit!';
        content.querySelector('#view-signIn-error').classList.remove('d-none');
      }
      console.log(response);
      */ /*
    });
    */ });
    return content;
};


var $b628e8ddd8340e8e$exports = {};
$b628e8ddd8340e8e$exports = "<div class=\"app-route-signUp container\">\n\n  <div class=\"end-0 m-3 position-absolute top-0\">\n    <div class=dropdown>\n      <a class=\"btn btn-dark dropdown-toggle\" data-bs-toggle=dropdown href=# role=button>\n        <i class=\"fa-globe fa-solid\"></i>\n      </a>\n      <ul class=dropdown-menu>\n        <li>\n          <a class=\"active dropdown-item\" href=#>\n            English\n          </a>\n        </li>\n      </ul>\n    </div>\n  </div>\n\n  <a href=/>\n    <img alt class=\"app-logo-text d-block m-auto\" src=/logo-text.f78b3fcb.png style=height:10rem>\n  </a>\n\n  <form class=\"mx-auto was-validated\" id=app-form-signUp style=max-width:600px>\n\n    <hr>\n\n    <h5 data-i18n=view-signUp-profile></h5>\n\n    <div class=row>\n      <div class=col-md-6>\n        <div class=\"form-floating mb-3\">\n          <input class=form-control data-i18n-placeholder=view-signUp-nameFirstPlaceholder id=app-form-signUp-nameFirst maxlength=100 minlength=2 name=nameFirst required>\n          <label data-i18n=view-signUp-nameFirstLabel for=app-form-signUp-nameFirst></label>\n          <div class=invalid-feedback data-i18n=view-signUp-nameFirstFeedback></div>\n        </div>\n      </div>\n      \n      <div class=col-md-6>\n        <div class=\"form-floating mb-3\">\n          <input class=form-control data-i18n-placeholder=view-signUp-nameLastPlaceholder id=app-form-signUp-nameLast maxlength=100 minlength=2 name=nameLast required>\n          <label data-i18n=view-signUp-nameLastLabel for=app-form-signUp-nameLast></label>\n          <div class=invalid-feedback data-i18n=view-signUp-nameFirstFeedback></div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"form-floating mb-3\">\n      <select class=form-select id=app-form-signUp-biologicalSex name=biologicalSex required>\n        <option data-i18n=view-signUp-biologicalSexOption0 disabled selected value></option>\n        <option data-i18n=view-signUp-biologicalSexOption1 value=female></option>\n        <option data-i18n=view-signUp-biologicalSexOption2 value=male></option>\n        <option data-i18n=view-signUp-biologicalSexOption3 value=other></option>\n      </select>\n      <label data-i18n=view-signUp-biologicalSexLabel for=app-form-signUp-biologicalSex></label>\n      <div class=invalid-feedback data-i18n=view-signUp-biologicalSexFeedback></div>\n    </div>\n\n    <div class=\"form-floating mb-3\">\n      <input class=form-control data-i18n-placeholder=view-signUp-dateOfBirthPlaceholder id=app-form-signUp-dateOfBirth name=dateOfBirth required type=date>\n      <label data-i18n=view-signUp-dateOfBirthLabel for=app-form-signUp-dateOfBirth></label>\n      <div class=invalid-feedback data-i18n=view-signUp-dateOfBirthFeedback></div>\n    </div>\n\n    <hr>\n\n    <h5 data-i18n=view-signUp-authentication></h5>\n\n    <div class=\"form-floating mb-3\">\n      <input class=form-control data-i18n-placeholder=view-signUp-emailPlaceholder id=app-form-signUp-email name=email required type=email>\n      <label data-i18n=view-signUp-emailLabel for=app-form-signUp-email></label>\n      <div class=invalid-feedback data-i18n=view-signUp-emailFeedback></div>\n    </div>\n\n    <div class=row>\n      <div class=col-md-6>\n        <div class=\"form-floating mb-3\">\n          <input autocomplete=new-password class=form-control data-i18n-placeholder=view-signUp-passwordPlaceholder id=app-form-signUp-password minlength=8 name=password required type=password>\n          <label data-i18n=view-signUp-passwordLabel for=app-form-signUp-password></label>\n          <div class=invalid-feedback data-i18n=view-signUp-passwordFeedback></div>\n        </div>\n      </div>\n      <div class=col-md-6>\n        <div class=\"form-floating mb-3\">\n          <input autocomplete=new-password class=form-control data-i18n-placeholder=view-signUp-passwordConfirmPlaceholder id=app-form-signUp-passwordConfirm minlength=8 name=passwordConfirm required type=password>\n          <label data-i18n=view-signUp-passwordConfirmLabel for=app-form-signUp-profile-password></label>\n          <div class=invalid-feedback data-i18n=view-signUp-passwordConfirmFeedback></div>\n        </div>\n      </div>\n    </div>\n\n    <hr>\n\n    <h5 data-i18n=view-signUp-agreements></h5>\n\n    <div class=\"form-check form-switch\">\n      <input class=form-check-input id=app-form-signUp-agreement1 name=agreement1 required role=switch type=checkbox>\n      <label class=form-check-label data-i18n=view-signUp-agreement1Label for=app-form-signUp-agreement1></label>\n      <div class=invalid-feedback data-i18n=view-signUp-agreement1Feedback></div>\n    </div>\n\n    <hr>\n\n    <button class=\"btn btn-primary d-block mb-3 mx-auto px-5\" data-i18n=view-signUp-signUp id=app-form-signUp-submit> <i class=\"fa-fw fa-solid fa-user-plus\"></i> Continue </button> </form>\n  \n</div>\n\n<div class=\"fade modal\" id=app-modal-signUp-agreement1 tabindex=-1>\n  <div class=\"modal-dialog modal-dialog-centered\">\n    <div class=modal-content>\n      <div class=modal-header>\n        <h1 class=\"fs-5 modal-title\" data-i18n=view-signUp-agreement1Title></h1>\n        <button class=btn-close data-bs-dismiss=modal type=button></button>\n      </div>\n      <div class=modal-body data-i18n=view-signUp-agreement1Body></div>\n      <div class=modal-footer>\n        <button class=\"btn btn-secondary\" data-bs-dismiss=modal data-i18n=view-signUp-close type=button></button>\n      </div>\n    </div>\n  </div>\n</div>\n";



var $efb8c776f05259d5$export$2e2bcd8739ae039 = ()=>{
    const content = document.createElement('div');
    /*
  content.classList.add('align-items-center');
  content.classList.add('d-flex');
  //content.classList.add('h-100');
  content.classList.add('py-5');
  */ content.classList.add('align-items-center', 'd-flex', 'h-auto', 'justify-content-center', //'mh-100',
    'w-100');
    content.innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($b628e8ddd8340e8e$exports)));
    const title = `${(0, $388b617130f03bd4$export$2e2bcd8739ae039).run.settings.view.signUp.pageTitle}${(0, $388b617130f03bd4$export$2e2bcd8739ae039).run.settings.siteTitleSeparator}${(0, $388b617130f03bd4$export$2e2bcd8739ae039).run.settings.siteTitle}`;
    document.title = title;
    content.querySelector('#app-form-signUp-passwordConfirm').addEventListener('keyup', ()=>{
        console.log('SATAN!');
    });
    const form = content.querySelector('#app-form-signUp');
    form.addEventListener('submit', (e)=>{
        e.preventDefault();
        const data = {};
        const formData = new FormData(form);
        formData.forEach((value, key)=>{
            data[key] = value;
        });
        const json = JSON.stringify(data);
        console.log(formData);
        console.log(data);
        console.log(json);
        fetch('/api/sign-up', {
            body: json,
            headers: (0, $388b617130f03bd4$export$2e2bcd8739ae039).run.headers,
            method: 'POST'
        }).then((response)=>{
            console.log(response);
        });
    });
    return content;
};


const $0d253f80dc492c18$var$view = {
    landing: $549aaec9bbffe278$export$2e2bcd8739ae039,
    notFound: $6e61814d093d589e$export$2e2bcd8739ae039,
    signIn: $8981953cfc52913d$export$2e2bcd8739ae039,
    signUp: $efb8c776f05259d5$export$2e2bcd8739ae039
};
var $0d253f80dc492c18$export$2e2bcd8739ae039 = $0d253f80dc492c18$var$view;


const $3e27a66f4ef69c2e$var$router = async (route)=>{
    const content = document.getElementById('app-content');
    content.innerHTML = '';
    switch(route){
        case '':
            content.appendChild((0, $0d253f80dc492c18$export$2e2bcd8739ae039).landing());
            break;
        case '#/sign-in':
            content.appendChild((0, $0d253f80dc492c18$export$2e2bcd8739ae039).signIn());
            break;
        case '#/sign-up':
            content.appendChild((0, $0d253f80dc492c18$export$2e2bcd8739ae039).signUp());
            break;
        default:
            content.appendChild((0, $0d253f80dc492c18$export$2e2bcd8739ae039).notFound());
    }
    (0, $388b617130f03bd4$export$2e2bcd8739ae039).lib.i18n.render();
};
var $3e27a66f4ef69c2e$export$2e2bcd8739ae039 = $3e27a66f4ef69c2e$var$router;



const $480eb26aa317c74a$var$settings = {
    run: async ()=>{
        const response = await fetch(`/api/settings?i18n=${(0, $388b617130f03bd4$export$2e2bcd8739ae039).run.i18n}`, {
            headers: (0, $388b617130f03bd4$export$2e2bcd8739ae039).run.headers
        });
        const json = await response.json();
        (0, $388b617130f03bd4$export$2e2bcd8739ae039).run.settings = json.settings;
        (0, $388b617130f03bd4$export$2e2bcd8739ae039).lib.token.set(json._token);
    }
};
var $480eb26aa317c74a$export$2e2bcd8739ae039 = $480eb26aa317c74a$var$settings;



const $9ba1f1e474428508$var$token = {
    check: (jwt)=>{
        if (jwt.exp < Math.floor(Date.now() / 1000)) return false;
        return true;
    },
    get: async ()=>{
        const response = await fetch('/api/token');
        const json = await response.json();
        const jwt = json._token;
        return jwt;
    },
    parse: (jwt)=>{
        const base64Url = jwt.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map((c)=>`%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`).join(''));
        return JSON.parse(jsonPayload);
    },
    run: async ()=>{
        let fetchedJWT = null;
        let storedJWT = localStorage.getItem('token');
        if (storedJWT === 'undefined') storedJWT = false;
        if (!storedJWT) {
            fetchedJWT = await $9ba1f1e474428508$var$token.get();
            $9ba1f1e474428508$var$token.set(fetchedJWT);
        } else if (!$9ba1f1e474428508$var$token.check($9ba1f1e474428508$var$token.parse(storedJWT))) {
            fetchedJWT = await $9ba1f1e474428508$var$token.get();
            $9ba1f1e474428508$var$token.set(fetchedJWT);
        } else $9ba1f1e474428508$var$token.set(storedJWT);
    /*
    const lifetimeText = document.getElementById('app-token-lifetime');
    const liefeTimeInterval = setInterval(() => {
      const exp = token.parse(app.run.token).exp;
      const now = Math.floor(Date.now() / 1000);

      const diff = exp - now;

      lifetimeText.innerHTML = `Token will expire in ${diff} seconds`;

      if (diff === 0 || diff < 0) {
        clearInterval(liefeTimeInterval);
        lifetimeText.innerHTML = 'Token has expired!';
        window.location = '/?token-expired';
      }
    }, 1000);
    */ },
    set: (jwt)=>{
        (0, $388b617130f03bd4$export$2e2bcd8739ae039).run.headers = {
            'Authorization': `Bearer ${jwt}`
        };
        (0, $388b617130f03bd4$export$2e2bcd8739ae039).run.token = jwt;
        localStorage.setItem('token', jwt);
    }
};
var $9ba1f1e474428508$export$2e2bcd8739ae039 = $9ba1f1e474428508$var$token;


(0, $388b617130f03bd4$export$2e2bcd8739ae039).lib.i18n = (0, $9e30b5b5de697b16$export$2e2bcd8739ae039);
(0, $388b617130f03bd4$export$2e2bcd8739ae039).lib.router = (0, $3e27a66f4ef69c2e$export$2e2bcd8739ae039);
(0, $388b617130f03bd4$export$2e2bcd8739ae039).lib.settings = (0, $480eb26aa317c74a$export$2e2bcd8739ae039);
(0, $388b617130f03bd4$export$2e2bcd8739ae039).lib.token = (0, $9ba1f1e474428508$export$2e2bcd8739ae039);
(0, $388b617130f03bd4$export$2e2bcd8739ae039).fn.run();


//# sourceMappingURL=app.863573d1.js.map
